import type { ReactNode, FC } from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { sanitizeHref } from '@wix/da-url';
import s from './BackButton.scss';

interface Props {
  href: string;
  children?: ReactNode;
}

const BackButton: FC<Props> = ({ href, children }) => (
  <TextButton className={s['root']} href={sanitizeHref(href)} size="small" variant="main">
    <ArrowLeft className={s['icon']} disableDefaultColors size={IconSize.SMALL} />
    <span className={s['text']}>{children}</span>
  </TextButton>
);
BackButton.displayName = 'BackButton';

export default BackButton;
